/**
 * Directional damage arc.
 *
 * `state.damageFlash` carries the attacker's world XZ; the bearing on screen is
 * that point relative to the local player's position and yaw, so the indicator
 * keeps pointing at the shooter as the player turns.
 */
import { el, setOpacity, setRotate } from './dom.js';

const LIFE = 1.1;
const RAD2DEG = 180 / Math.PI;

export class DamageArc {
  constructor(parent) {
    const root = el('div', 'cs-dmg', parent);
    el('i', null, root);
    this.root = root;
    this._lastT = 0;
    this._timer = 0;
  }

  /**
   * @param flash  state.damageFlash
   * @param px,pz  local player world position
   * @param yaw    local player yaw (radians, three.js YXZ convention)
   */
  update(flash, dt, px, pz, yaw) {
    const t = flash?.t ?? 0;
    if (t !== this._lastT) {
      this._lastT = t;
      this._timer = t ? LIFE : 0;
    }
    if (this._timer <= 0) {
      if (this.root.__o !== 0) setOpacity(this.root, 0);
      return;
    }
    this._timer -= dt;

    const dx = (flash?.fromX ?? 0) - px;
    const dz = (flash?.fromZ ?? 0) - pz;
    const sy = Math.sin(yaw);
    const cy = Math.cos(yaw);
    // Forward is (-sin y, -cos y); right is (cos y, -sin y). 0 deg = ahead.
    const ahead = -dx * sy - dz * cy;
    const right = dx * cy - dz * sy;
    setRotate(this.root, Math.atan2(right, ahead) * RAD2DEG);

    const k = Math.max(0, this._timer / LIFE);
    setOpacity(this.root, k * k);
  }
}
